import get from 'lodash.get';

const i18nBase = 'fundraiser.fundraiser-view.mark-spam-modal';

/** Actions that always apply (page-level) */
const pageActions = [
  `${i18nBase}.action-redirect`,
  `${i18nBase}.action-archive`,
  `${i18nBase}.action-private`,
  `${i18nBase}.action-flag-page`,
];

/** Actions that only apply when the fundraiser has an account */
const accountActions = [
  `${i18nBase}.action-logout`,
  `${i18nBase}.action-lockout`,
];

/** Returns the list of i18n keys for actions that will be performed */
export const getSpamActionKeys = (fundraiser: any): string[] => {
  const accountId = get(fundraiser, 'manager.id') || get(fundraiser, 'accountId');
  return accountId ? [...pageActions, ...accountActions] : [...pageActions];
};

/** Returns the appropriate i18n context key based on whether the fundraiser has an owner */
export const getSpamModalContextKey = (fundraiser: any): string => {
  const accountId = get(fundraiser, 'manager.id') || get(fundraiser, 'accountId');
  return accountId
    ? `${i18nBase}.context-with-owner`
    : `${i18nBase}.context-without-owner`;
};

/** Returns i18n interpolation params for the modal context string */
export const getSpamModalContextParams = (fundraiser: any): Record<string, string> => {
  const name = get(fundraiser, 'name', '');
  const ownerFirstName = get(fundraiser, 'manager.firstName', '');
  const ownerLastName = get(fundraiser, 'manager.lastName', '');
  const ownerEmail = get(fundraiser, 'manager.email', '');
  const ownerName = [ownerFirstName, ownerLastName].filter(Boolean).join(' ');

  return {
    fundraiserName: name,
    ownerName,
    ownerEmail,
  };
};
